// Copyright (c) Proto Labs, Inc. All Rights Reserved.
import { TokenManagerEventTypes } from './TokenManagerEventTypes';
export class TokenManagerEventPublisher {
    constructor(logger) {
        this.logger = logger;
        this.theWindow = window;
    }
    publishAuthenticationChanged(isAuthenticated) {
        this.logger.info(`TokenManagerEventPublisher.publishAuthenticationChanged: is authenticated is ${isAuthenticated}.`);
        this.publish(TokenManagerEventTypes.AuthenticationChanged, {
            isAuthenticated: isAuthenticated,
        });
    }
    publishClaimsUpdated() {
        this.logger.info('TokenManagerEventPublisher.publishClaimsUpdated.');
        this.publish(TokenManagerEventTypes.ClaimsUpdated);
    }
    publish(type, detail = {}) {
        this.theWindow.dispatchEvent(new CustomEvent(type, { detail }));
    }
}
//# sourceMappingURL=TokenManagerEventPublisher.js.map